import reusables from '@styles/theme/reusables';
import theme from '@styles/theme';
export default {
  filterList: {
    listStyleType: 'none'
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'column'
  },
  radio: (isDropdown: boolean, index: number) => ({
    mt: isDropdown && index === 0 ? 0 : '16px',
    mb: isDropdown ? 0 : '10px',
    display: 'flex',
    flex: 1,
    label: {
      transform: 'translateY(-2px)',
      cursor: 'pointer',
      display: 'inline-flex'
    },
    '&:last-child': {
      mb: 0
    }
  }),
  radioContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  filterElement: (isDropdown: boolean) => {
    const size = isDropdown ? '24px' : '40px';
    return {
      height: size,
      display: 'inline-flex',
      width: '100%',
      mt: isDropdown ? '' : '16px',
      '&:last-child': {
        mb: 0
      },
      span: {
        height: size,
        lineHeight: size,
        display: 'inline-block'
      }
    };
  },
  imgWrapper: (isActive: boolean, isDropdown: boolean) => {
    const size = isDropdown ? '24px' : '40px';
    return {
      borderRadius: '50%',
      position: 'relative',
      border: `1px solid ${isActive ? theme.rawColors.accent700 : theme.rawColors.lightGrey300}`,
      overflow: 'hidden',
      mr: '16px',
      maxHeight: size,
      maxWidth: size
    };
  },
  buttonWrapper: {
    background: 'none',
    outline: 'none',
    border: 'none',
    display: 'inline-flex',
    userSelect: 'none',
    width: '100%',
    color: theme.rawColors.neutralBlack,
    ...reusables.mainTransition('color'),
    '&:hover': {
      color: theme.rawColors.accent700
    }
  },
  checkIcon: (isActive: boolean) => ({
    display: isActive ? 'inline-block' : 'none',
    position: 'absolute',
    top: 'calc(50% + 2px)',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: theme.zIndex.documentUp
  }),
  count: {
    width: '20px',
    textAlign: 'center',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.rawColors.darkGrey500
  }
};